export default {
  section: 'Productos',
  loading: 'Cargando productos...',
  actions: {
    save: 'Guardar',
    create: 'Crear',
    close: 'Cerrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar'
  },
  sidePanel: {
    title: 'Impuestos',
    loading: 'Cargando impuestos ...',
    headers: {
      name: 'Nombre',
      base: 'Cantidad',
      kind: 'Tipo de impuesto',
      isRetention: 'Trasladado o Retenido',
      isQuota: 'Tasa o Cuota',
      baseAmount: 'Base del impuesto',
      action: 'Acciones'
    }
  },
  modals: {
    removeTax: {
      title: '¿Deseas eliminar el impuesto?'
    },
    addSatCode: {
      title: 'Agrega Clave del SAT',
      successAction: 'Agregar CLAVE',
      cancelAction: 'Cancelar'
    },
    addProduct: {
      title: 'Crear producto',
      name: 'Nombre del producto',
      departament: 'Departamento',
      sectionProduct: 'Sección de producto',
      type: 'Tipo',
      success: 'Crear producto',
      cancel: 'Cancelar'
    },
    addVariant: {
      title: 'Agregar presentación',
      infoSubtitle: 'Información comercial',
      warehouseSubtitle: 'Información de almacén',
      description: 'Descripción del producto',
      aliasesProvider: 'Alias que usas en las facturas para este producto',
      price: 'Precio sin impuestos',
      priceWithTaxes: 'Precio con impuestos',
      cost: 'Costo del producto',
      name: 'Nombre del producto',
      displayQuantity: 'Cantidad de presentación',
      displayUnit: 'Unidad de presentación',
      contentQuantity: 'Cantidad de contenido',
      contentUnit: 'Unidad de contenido',
      brand: 'Marca',
      success: 'Agregar presentación',
      save: 'Guardar cambios',
      cancel: 'Cancelar'
    }
  },
  labels: {
    name: 'Nombre',
    internalId: 'ID',
    price: 'Precio de venta',
    recipe: 'Platillo',
    quantity: 'Cantidad',
    tax: 'Impuesto',
    taxKind: 'Tipo de impuesto',
    taxType: '¿Es tasa o cuota?',
    taxAmount: 'Base del impuesto',
    taxBase: '¿De cuánto el la tasa o la cuota?',
    addTaxes: 'Agregar impuesto',
    editTaxes: 'Guardar impuesto',
    cancel: 'Cancelar',
    satCode: 'Código de SAT',
    percentage: '¿Es porcentaje?'
  },
  placeholders: {
    name: 'Nombre',
    internalId: 'ID',
    price: 'Precio de venta',
    tax: 'Selecciona el impuesto',
    taxKind: 'Selecciona el tipo de impuesto',
    taxType: 'Selecciona tasa o cuota',
    recipe: 'Platillo/Bebida para agregar',
    quantity: 'Cantidad de impuesto aplicado',
    satCode: 'Agrega el código del SAT',
    percentage: '¿Se aplicará en porcentaje?'
  },
  headers: {
    date: 'Fecha de operación',
    dateAccountable: 'Fecha contable',
    type: 'Tipo de operación',
    productType: 'Tipo',
    name: 'Nombre del producto',
    departament: 'Departamento',
    displayUnit: 'Unidad de presentación',
    displayQuantity: 'Cantidad de presentación',
    contentQuantity: 'Cantidad de contenido',
    brand: 'Marca',
    warehouseQuantity: 'Cantidad en almacén',
    taxes: 'Impuestos',
    satCode: 'Código de SAT',
    status: 'Estatus',
    concept: 'Concepto',
    id: 'No. de identificación',
    amount: 'Importe',
    price: 'Precio',
    description: 'Descripción',
    priceWithTaxes: 'Precio con impuestos',
    amountPaid: 'Monto abonado',
    balance: 'Saldo',
    actions: 'Acciones'
  }
}
